// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3G2S6","tab":"Tabs_tab__1CgvL","tabActive":"Tabs_tabActive__39Knb"};